module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Binningen_BL-ebbc8b8d500acadbb0c2110614ad2bc4.svg";